/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_viewer = {
    readonly pdpHolidayShippingFeatureFlag: boolean | null;
    readonly relevantShipping: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_regionalInfo">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_viewer" | "PdpSharedShippingHolidayDelivery_viewer">;
    readonly " $refType": "PdpRespSidebarBlurbShipping_viewer";
};
export type PdpRespSidebarBlurbShipping_viewer$data = PdpRespSidebarBlurbShipping_viewer;
export type PdpRespSidebarBlurbShipping_viewer$key = {
    readonly " $data"?: PdpRespSidebarBlurbShipping_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_viewer",
  "selections": [
    {
      "alias": "pdpHolidayShippingFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpHolidayShipping"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpHolidayShipping\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "RelevantShippingInfo",
      "kind": "LinkedField",
      "name": "relevantShipping",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteRequestStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_viewer"
    },
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedShippingInfo_regionalInfo"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '986b567665004cfcc64b5c03dbed2d69';
export default node;
